import PurchaseScreen from './screen';
import { connect } from 'react-redux';

import {
  apply_promo_code,
  clear_promo_code,
  Logout,
  payment_authentication,
  promo_code_request,
} from '../../../../redux/actions';

const mapStateToProps = state => {

  return {
    state,
    loading: state.LoadingReducer.isLoading,
    userId: state.CommonReducer.userId,
    sessionToken: state.CommonReducer.sessionToken,
    isNetConnected: state.LoginReducer.isNetConnected,
    couponCode: state.CardPurchaseReducer.couponCode,
    netAmount: state.CardPurchaseReducer.netAmount,
    discountPrice: state.CardPurchaseReducer.discountPrice,
  };
};

const mapDispatchToProps = dispatch => {
  return {

    payment_authentication: (paymentBody, success, callback) => dispatch(payment_authentication(paymentBody, success, callback)),

    promo_code_request: requestBody => dispatch(promo_code_request(requestBody)),

    apply_promo_code: requestBody => dispatch(apply_promo_code(requestBody)),

    clear_promo_code: () => dispatch(clear_promo_code()),

    Logout: () => dispatch(Logout()),

  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseScreen);
